import { QuoteCountStatusRequest } from "@/main/models/request/quoteRequest";
import { QuoteResponseCount } from "@/main/models/response";

export enum QuoteCountStatusTypes {
	GET_QUOTE_COUNT_STATUS = "@quoteCountStatus/GET_QUOTE_COUNT_STATUS",
	SAVE_QUOTE_COUNT_STATUS = "@quoteCountStatus/SAVE_QUOTE_COUNT_STATUS",
	RESET_REDUCER_QUOTE_COUNT_STATUS = "@quoteCountStatus/RESET_REDUCER_QUOTE_COUNT_STATUS",
}

export interface QuoteCountStatusState {
	readonly quoteCountStatus: {
		data: QuoteResponseCount[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetQuoteCountStatus {
	type: typeof QuoteCountStatusTypes.GET_QUOTE_COUNT_STATUS;
	payload: {
		request: QuoteCountStatusRequest;
	};
}

export interface SaveQuoteCountStatus {
	type: typeof QuoteCountStatusTypes.SAVE_QUOTE_COUNT_STATUS;
	payload: {
		data: QuoteResponseCount[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerQuoteCountStatus {
	type: typeof QuoteCountStatusTypes.RESET_REDUCER_QUOTE_COUNT_STATUS;
}

export type QuoteCountStatusActionTypes = GetQuoteCountStatus | SaveQuoteCountStatus | ResetReducerQuoteCountStatus;
